import {NumberUDF} from "./UDFs/NumberUDF";
import {StringUDF} from "./UDFs/StringUDF";

export class ReplenishmentConfiguration{

  ReplenishmentReportId: NumberUDF;
  SearchPosition: NumberUDF;
  StoreIDFilterLabel: StringUDF;


  get(): any {
    return {
      ReplenishmentReportId: this.ReplenishmentReportId.value,
      SearchPosition: this.SearchPosition.value,
      StoreIDFilterLabel:this.StoreIDFilterLabel.value
    };
  }
}



// WEBPACK FOOTER //
// ./src/models/replenishment.config.ts